import { createTheme } from '@mui/material';

export const landingTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#D4763A', dark: '#A85A26', contrastText: '#F4EFE6' },
    secondary: { main: '#2D4A2B' },
    background: { default: '#F4EFE6', paper: '#F4EFE6' },
    text: { primary: '#1A1814', secondary: '#4A4239' },
  },
  typography: {
    fontFamily: '"Plus Jakarta Sans Variable", system-ui, sans-serif',
    h1: {
      fontFamily: '"Fraunces Variable", Georgia, serif',
      fontWeight: 400,
      fontVariationSettings: '"opsz" 144, "SOFT" 100, "WONK" 1',
      letterSpacing: '-0.03em',
      lineHeight: 0.96,
    },
    h2: {
      fontFamily: '"Fraunces Variable", Georgia, serif',
      fontWeight: 500,
      letterSpacing: '-0.02em',
    },
    body1: { letterSpacing: '-0.01em' },
    button: {
      fontFamily: '"JetBrains Mono Variable", monospace',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.08em',
    },
    overline: {
      fontFamily: '"JetBrains Mono Variable", monospace',
      fontWeight: 500,
      letterSpacing: '0.16em',
      fontSize: '0.75rem',
    },
  },
  shape: { borderRadius: 0 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          padding: '18px 32px',
          transition: 'all 240ms cubic-bezier(0.2, 0, 0.2, 1)',
        },
      },
    },
  },
});
